//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  SfTabs,
  SfHeading,
  SfProperty,
  SfPrice,
  SfCollectedProduct
} from '@storefront-ui/vue';
import { computed } from '@nuxtjs/composition-api';
import { useWishlist, useUser, wishlistGetters, productGetters } from '@bee-hole/coms';
import { useUiState } from '~/composables';
import { addBasePath } from '@vue-storefront/core';

export default {
  name: 'Wishlist',
  components: {
    SfTabs,
    SfHeading,
    SfProperty,
    SfPrice,
    SfCollectedProduct
  },
  setup() {
    const { isWishlistSidebarOpen, toggleWishlistSidebar } = useUiState();
    const { wishlist, removeItem } = useWishlist();
    const { isAuthenticated } = useUser();
    const products = computed(() => wishlistGetters.getItems(wishlist.value));
    const totals = computed(() => wishlistGetters.getTotals(wishlist.value));
    const totalItems = computed(() => wishlistGetters.getTotalItems(wishlist.value));

    return {
      addBasePath,
      isAuthenticated,
      products,
      removeItem,
      isWishlistSidebarOpen,
      toggleWishlistSidebar,
      totals,
      totalItems,
      wishlistGetters,
      productGetters
    };
  }
};
